import { render, staticRenderFns } from "./FeaturedProgramming.vue?vue&type=template&id=83ab132e&"
import script from "./FeaturedProgramming.vue?vue&type=script&lang=js&"
export * from "./FeaturedProgramming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports